export default class Gesture extends Phaser.Group {
  constructor(game, x, y, type) {
    super(game);

    this.type = type;

    this.hand = this.game.make.image(0, 0, 'hand');
    this.hand.anchor.set(1, 0);
    this.hand.x = this.hand.width * 0.5;
    this.hand.y = -this.hand.height * 0.5;
    this.addChild(this.hand);

    this.scaleMax = 1;
    if (this.game.deviceMetric.platform.type === 'desktop') {
      this.scaleMax = 0.5;
    }

    this.x = x + this.hand.width * 0.3 * this.scaleMax;
    this.y = y - this.hand.height * 0.4 * this.scaleMax;
  }

  get depth() {
    return this.y + 1100;
  }

  tap() {
    this.scale.set(0);
    this.alpha = 0;
    const tween1 = this.game.add
      .tween(this.scale)
      .to({ x: this.scaleMax, y: this.scaleMax }, 250, Phaser.Easing.Quadratic.Out);
    const tween2 = this.game.add
      .tween(this)
      .to({ alpha: 1, angle: 20 }, 250, Phaser.Easing.Quadratic.Out);

    const tween3 = this.game.add
      .tween(this.hand)
      .to({ angle: -30 }, 200, Phaser.Easing.Quadratic.Out, false, 500);
    const tween4 = this.game.add
      .tween(this.hand)
      .to({ angle: 0 }, 200, Phaser.Easing.Quadratic.Out, false, 100);
    tween4.onComplete.addOnce(this.hideHand, this);

    // chaining tweens
    tween3.chain(tween4);
    tween2.chain(tween3);

    //
    tween1.start();
    tween2.start();
  }

  slide(side = 'right') {
    this.scale.set(0);
    this.alpha = 0;
    const tween1 = this.game.add
      .tween(this.scale)
      .to({ x: this.scaleMax, y: this.scaleMax }, 250, Phaser.Easing.Quadratic.Out);
    const tween2 = this.game.add
      .tween(this)
      .to({ alpha: 1, angle: 20 }, 250, Phaser.Easing.Quadratic.Out);

    const tween3 = this.game.add
      .tween(this.hand)
      .to({ angle: -30 }, 200, Phaser.Easing.Quadratic.Out, false, 500);
    const tween4 = this.game.add
      .tween(this)
      .to({ x: side === 'right' ? '+100' : '-100' }, 500, Phaser.Easing.Quadratic.Out, false, 100);
    tween4.onComplete.addOnce(this.hideHand, this);

    // chaining tweens
    tween3.chain(tween4);
    tween2.chain(tween3);

    //
    tween1.start();
    tween2.start();
  }

  hideHand() {
    this.game.add.tween(this).to({ angle: 0 }, 250, Phaser.Easing.Quadratic.Out, true, 500);
    this.game.add
      .tween(this.scale)
      .to({ x: 0, y: 0 }, 250, Phaser.Easing.Quadratic.Out, true, 500)
      .onComplete.add(this.handleHideEnd, this);
  }

  handleHideEnd() {
    this.destroy();
  }
}
